module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-left.8e2759c6.svg";